import { LucideIcon } from "lucide-react";
import { cn } from "../lib/utils";



export default function StatCard({
  name,
  value,
  change,
  changeType,
  icon: Icon,
  iconBg,
  iconColor,
}) {
  return (
    <div className=" bg-white bg-card rounded-xl border border-border p-6 transition-all hover:shadow-lg">
      <div className="flex items-center gap-4">
        <div className={cn("rounded-lg p-3", iconBg)}>
          <Icon className={cn("h-6 w-6", iconColor)} />
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground">{name}</p>
          <p className="text-2xl font-bold text-foreground mt-1">{value||0}</p>
          <p
            className={cn(
              "text-xs font-medium mt-1",
              changeType === "positive" ? "text-green-600" : "text-red-600"
            )}
          >
            {change}
          </p>
        </div>
      </div>
    </div>
  );
}
